/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".redirection-banner[_ngcontent-%COMP%]{padding:16px;border:1px solid #d3d3d3;border-radius:4px;margin-top:10px;margin-bottom:15px;display:flex;flex-direction:column;align-items:center}.redirection-banner[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-bottom:15px}.redirection-banner[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
